var React = require('react');

function Medal148px (props) {
    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M43.72 10.012c.012.063.007.125.007.188 0 .065.005.128-.008.193-.013.069-.044.13-.072.195-.02.047-.025.096-.052.14L32.828 28.159c1.272 2.066 1.971 4.409 1.971 6.841 0 7.169-5.796 13-12.921 13-7.124 0-12.921-5.831-12.921-13 0-2.436.699-4.778 1.972-6.842L.161 10.728c-.027-.044-.032-.093-.051-.139-.028-.065-.059-.127-.073-.196-.012-.065-.008-.127-.008-.192 0-.064-.005-.125.007-.189.014-.07.045-.133.073-.2.019-.045.024-.093.05-.137l5.633-9.2c.015-.024.043-.035.06-.058a.972.972 0 0 1 .24-.23c.036-.025.067-.053.107-.072A.962.962 0 0 1 6.638 0h29.718c.148 0 .285.037.41.094.111-.043.22-.092.341-.094h.011c.345 0 .665.179.847.475l5.632 9.2c.026.043.031.092.05.137.028.067.06.13.073.2zM21.878 46c6.029 0 10.933-4.935 10.933-11 0-2.24-.671-4.404-1.941-6.259a10.93 10.93 0 0 0-6.712-4.509 11.38 11.38 0 0 0-4.57.002 10.933 10.933 0 0 0-6.703 4.508A11.035 11.035 0 0 0 10.945 35c0 6.065 4.905 11 10.933 11zm1.745-23.877L29.538 12H14.219l5.918 10.13a13.426 13.426 0 0 1 3.486-.007zM6.619 2.939l-4.444 7.259L12.19 26.411a12.89 12.89 0 0 1 5.897-3.842L6.619 2.939zM13.05 10h17.657l4.674-8H8.376l4.674 8zm24.087-7.061L25.649 22.603c2.296.714 4.343 2.005 5.918 3.807l10.015-16.213-4.445-7.258z","key":1})]);
}

Medal148px.displayName = "Medal148px";

Medal148px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 43.75 48"};

module.exports = Medal148px;

Medal148px.default = Medal148px;



//////////////////
// WEBPACK FOOTER
// ./data/assets/sprites/48px/medal-1-48px.svg
// module id = 1146
// module chunks = 0